module.exports = __webpack_public_path__ + "img/share-pink.f51910df.svg";